import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import SearchBar from './components/SearchBar';
import Home from './views/Home';
import Services from './views/Services';
import Research from './views/Research';
import Resources from './views/Resources';
import About from './views/About';
import People from './views/People';
import Contact from './views/Contact';
import Careers from './views/Careers';
import WealthManagement from './views/WealthManagement';
import ServiceDetail from './views/ServiceDetail';
import SearchResults from './views/SearchResults';
import Error404 from './views/Error404';
import ProductList from './views/ProductList';
import ServiceList from './views/ServiceList';
import OurPeople from './views/OurPeople';
import CreditRating from './views/CreditRating';
import Culture from './views/Culture';
import SubmitApplication from './views/SubmitApplication';
import ProductDetail from './views/ProductDetail';
import OurStory from './views/OurStory';

import './App.css';


function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Navigation />
          <Switch>
            <Route path="/" exact component={Home} />
            {/* <Route path="/services" exact component={Services} />
            <Route path="/services/wealthmanagement" component={WealthManagement} />
            <Route path="/services/:service" component={ServiceDetail} /> */}
            <Route path="/research" component={Research} />
            <Route path="/resources/:tabview" component={Resources} />
            <Route path="/about" component={About} />
            <Route path="/people" component={People} />
            <Route path="/contact" component={Contact} />
            <Route path="/careers" component={Careers} />
            <Route path="/search" component={SearchResults} />
            <Route path="/ourpeople" component={OurPeople} />
            <Route path="/creditrating" component={CreditRating} />
            <Route path="/culture" component={Culture} />
            <Route path="/application" component={SubmitApplication} />
            <Route path="/ourstory" component={OurStory} />
            <Route path="/error" component={Error404} />

            <Route path="/productlist" exact component={ProductList} />
            <Route path="/productlist/:tabview" exact component={ProductList} />
            <Route path="/productlist/:tabview/:product" component={ProductDetail} />

            <Route path="/servicelist" exact component={ServiceList} />
            <Route path="/servicelist/:tabview" exact component={ServiceList} />
            <Route path="/servicelist/:tabview/:service" component={ServiceDetail} />
            <Route component={Error404} />
          </Switch>
          <SearchBar />
          <Footer />
        </div>
      </Router>
    </div>
  );
}

export default App;
